/* ---------- Footer email signup → Klaviyo ----------
 * The mobile footer signup is a native Shopify {% form 'customer' %} (which only
 * creates a Shopify customer). This progressively enhances it: intercept the
 * submit and subscribe the email straight to a Klaviyo list via the public
 * client subscriptions API, so signups land in the list deterministically —
 * independent of any Shopify↔Klaviyo sync setting. With JS off, the native
 * Shopify form still posts as a fallback.
 *
 * Config (company/list ids) comes from data attributes on `.krg-footer__mobile`,
 * driven by the section's theme-editor settings.
 */
(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var KLAVIYO_REVISION = '2026-04-15';
  var MSG_STYLE = 'margin-top:10px;font-size:11px;letter-spacing:0.06em;text-transform:uppercase;';

  var root = document.querySelector('.krg-footer__mobile[data-krg-klaviyo-list]');
  if (!root) return;
  var company = (root.getAttribute('data-krg-klaviyo-company') || '').trim();
  var listId = (root.getAttribute('data-krg-klaviyo-list') || '').trim();
  var form = root.querySelector('form.krg-footer__signup');
  // No config → leave the native Shopify form untouched.
  if (!company || !listId || !form) return;

  var msg = document.createElement('p');
  msg.className = 'krg-footer__signup-msg';
  msg.setAttribute('aria-live', 'polite');
  msg.style.cssText = MSG_STYLE;
  msg.hidden = true;
  form.appendChild(msg);

  function show(text) {
    msg.textContent = text;
    msg.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var email = input && input.value ? input.value.trim() : '';
    if (!email) {
      show('Please enter your email address.');
      if (input) input.focus();
      return;
    }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    show('Signing you up…');

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Footer email signup (mobile)',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (res.ok) {
          // Klaviyo returns 202 Accepted on success.
          form.reset();
          show("Thanks — you're on the list.");
        } else {
          show('Something went wrong. Please try again.');
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        show('Something went wrong. Please try again.');
      });
  });
})();
